<template>
  <div id="card-news">
    <div class="card-releases">
      <div v-if="load || error" style="height: calc(100vh - 110px)" class="d-flex align-center justify-center">
        <Loader v-if="load" />
        <Error v-if="error" />
      </div>
      <div :class="[this.$lang === 'ar' ? 'flex-row-reverse' : '','release-header d-flex align-items-center justify-start']">
        <div :class="[this.$lang === 'ar' ? 'flex-row-reverse' : '','d-flex']">
          <img @click="$router.push('/home')" class="d-block icons" src="../../assets/icons/homeIcon.svg"/>
          <img :class="[this.$lang === 'ar' ? 'rotate' : '','d-block px-6']" src="../../assets/icons/rightArrow.svg"/>
        </div>
        <div v-for="(item, index) in items" :key="index" :class="['d-flex route icons', (lang === 'ar' ? 'bold-ar flex-row-reverse' : 'bold-en'), (index === items.length - 1 && lang === 'ar' ? 'bold-italic-ar' : index === items.length - 1 ? 'bold-italic-en' : '')]">
          <div @click="handleRoute" :class="[index === items.length - 1 ? 'yellow-txt' : '']">{{item.title}}</div>
          <img v-if="index < items.length - 1" :class="[lang === 'ar' ? 'rotate' : '','d-block px-6']" src="../../assets/icons/rightArrow.svg"/>
        </div>
      </div>
      <div v-if="!load && !error" class="releases-slider">
        <div class="position-relative">
          <!--          <div :class="[this.$lang === 'ar' ? 'back-arrow-right rotate' : 'back-arrow-left','back-arrow']">-->
          <!--            <img @click="$router.go(-1)" src="../../assets/icons/white-back-arrow.png"/>-->
          <!--          </div>-->
          <VueSlickCarousel
            :arrows="false"
            :infinite="true"
            :dots="true"
            :touchThreshold="5"
            :rtl="false"
            ref="slider1"
            :fade="true"
            :autoplay="true"
            :autoplaySpeed="6000"
            :pauseOnHover="false"
          >
            <div class="" v-for="(card , i) in images" :key="i">
              <div class="image-container position-relative" :style="{ 'background': 'url( ' + card + ') no-repeat', backgroundSize: 'cover'}">
              </div>
            </div>
          </VueSlickCarousel>
          <div class="swipe" v-if="images.length > 1">
            <div  v-observe-visibility="visibilityChanged"></div>
            <img class="icon" src="../../assets/icons/white-swipe.svg">
            <div class="swipe-icon">{{$t('swipe')}}</div>
          </div>
        </div>
      </div>
      <div v-if="!load && !error" :class="[this.$lang === 'ar' ? 'circle-ar' : 'circle-en', 'content-container']">
        <div :class="[this.$lang === 'ar' ? 'flex-row-reverse' : '','content-header']">
          <div :class="[this.$lang === 'ar' ? 'bold-italic-ar right-align' : 'bold-italic-en left-align', 'card-title']">{{info.title}}</div>
          <div @click="openDialog" class="share">
            <img src="../../assets/icons/yellow-share-btn.svg"/>
          </div>
        </div>
        <div :class="[this.$lang === 'ar' ? 'regular-ar right-align left-desc' : 'regular-en left-align right-desc','description']">
          <div :class="[this.$lang === 'ar' ? 'medium-ar' : 'medium-en', 'py-1']">{{info.date}}</div>
          <div class="click-address" v-html="info.desc"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Navbar from '../Navbar'
import card from '../../assets/images/press-releases-card.png'
import VueSlickCarousel from 'vue-slick-carousel-rtl'
import 'vue-slick-carousel-rtl/dist/vue-slick-carousel-rtl.css'
import 'vue-slick-carousel-rtl/dist/vue-slick-carousel-theme.css'
import SocialResponsibilityCardDetails from '../../repositories/SocialResponsibilityCardDetails'
import PressReleasesCardDetails from '../../repositories/PressReleasesCardDetails'
import $ from 'jquery'
import gc from '../../utils/gc'
import Error from '../../components/errorHandle/Error'
import Loader from '../../components/LoaderBtn/Loader'
// import Footer from '../../components/core/Footer'
export default {
  components: { Error, Loader, VueSlickCarousel },
  data () {
    return {
      image: card,
      lang: this.$lang,
      info: {
        title: '',
        date: '',
        desc: ''
      },
      images: [],
      items: [{
        title: this.$route.params.type === 'social' && this.$lang === 'ar' ? ' اجتماعية'
          : this.$route.params.type === 'social' ? this.$route.params.type.toUpperCase().slice(0, 1) + this.$route.params.type.slice(1)
            : this.$route.params.type === 'news' && this.$lang === 'ar' ? 'أخبار ' : this.$route.params.type.toUpperCase().slice(0, 1) + this.$route.params.type.slice(1)
      },
      {
        title: this.$lang === 'ar' ? 'تفاصيل' : 'Details'
      }],
      type: this.$route.params.type,
      id: this.$route.params.id,
      socialRepo: new SocialResponsibilityCardDetails(),
      pressRepo: new PressReleasesCardDetails(),
      load: false,
      error: false
    }
  },
  created () {
    this.getData()
  },
  methods: {
    visibilityChanged (isVisible) {
      $('.icon').addClass('swiping')
      setTimeout(() => {
        $('.icon').removeClass('swiping')
      }, 2000)
    },
    async getData () {
      const type = this.type === 'news' ? this.pressRepo : this.socialRepo
      this.load = true
      try {
        const response = await type.getById(`${this.id}/web`)
        if (response.status === 200) {
          if (this.type === 'news') {
            this.info.title = response.data.title
            this.info.desc = response.data.html
            this.info.date = response.data.date
            for (let i = 0; i < response.data.newsMedia.length; i++) {
              this.images.push(gc.baseUrl + '/customerCare' + response.data.newsMedia[i].media)
            }
          } else {
            this.info.title = response.data.title
            this.info.desc = response.data.text
            this.info.date = response.data.socialDate
            for (let i = 0; i < response.data.socialResponsibilityMedia.length; i++) {
              this.images.push(gc.baseUrl + '/customerCare' + response.data.socialResponsibilityMedia[i].media)
            }
          }
        } else {
          this.error = true
          this.load = false
        }
      } catch (e) {
        this.error = true
        this.load = false
        return e
      }
      this.load = false
      setTimeout(() => {
        this.handleResponsive()
      })
    },
    handleResponsive () {
      if (this.$store.state.window < 700) {
        this.$lang === 'ar' ? $('ul.slick-dots').css('left', '20px') : $('ul.slick-dots').css('right', '20px')
      } else if (this.$store.state.window >= 700 && this.$store.state.window < 1400) {
        this.$lang === 'ar' ? $('ul.slick-dots').css('left', '45px') : $('ul.slick-dots').css('right', '45px')
      } else if (this.$store.state.window >= 1400 && this.$store.state.window < 1800) {
        this.$lang === 'ar' ? $('ul.slick-dots').css('left', '55px') : $('ul.slick-dots').css('right', '55px')
      } else {
        this.$lang === 'ar' ? $('ul.slick-dots').css('left', '65px') : $('ul.slick-dots').css('right', '65px')
      }
    },
    handleRoute () {
      if (this.type === 'social') {
        this.$router.push('/about-mtn/social-responsibility')
        this.$store.state.tab = 2
      } else if (this.type === 'news') {
        this.$router.push('/about-mtn/press-center')
        this.$store.state.tab = 1
      } else {
        this.$router.push('/')
      }
    },
    openDialog () {
      this.$store.state.sharedMessage = this.info.title
      this.$store.state.sharingLink = gc.website + this.$route.path
      this.$store.state.sharing = true
      if (this.type === 'social') {
        this.$store.state.sharedTitle = this.$t('shareDialog.shareItem')
        this.$store.state.urlTitle = this.$t('shareDialog.social')
      } else if (this.type === 'news') {
        this.$store.state.sharedTitle = this.$t('shareDialog.shareNews')
        this.$store.state.urlTitle = this.$t('shareDialog.news')
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.handleResponsive()
    })
    this.$watch(() => {
      return this.$store.state.window
    }, (val) => {
      this.handleResponsive()
    })
  }
}
</script>
<style scoped lang="scss">
@import "src/assets/sass/main";
.swiping{
  animation-name: translate;
  animation-timing-function: ease-in-out;
  animation-duration: .5s;
  animation-iteration-count: 4;
  animation-direction: alternate;
}
@keyframes translate {
  from {
    transform: rotate(0deg)
  }
  to {
    transform: rotate(90deg)
  }
}
.card-releases{
  padding-top: 160px;
  //height: 100vh;
  min-height: calc(100vh - (170px));
  overflow-y: auto;
}
.yellow-txt {
  color: $--yellow;
}
.rotate{
  transform: rotate(180deg);
}
.icons{
  cursor: pointer;
}
.route{
  font-size: 13px;
}
.back-arrow-left{
  left: 80px;
}
.back-arrow-right{
  right: 80px;
}
.back-arrow{
  position: absolute;
  z-index: 1;
  top: 55px;
  cursor: pointer;
  width: 35px;
  img{
    height: 100%;
    width: 100%;
  }
}
.release-header{
  height: 50px;
  width: 100vw;
  background: rgba(242,242,242,1);
  padding: 0 86.5px;
  position: fixed;
  top: 110px;
  z-index: 202;
  box-shadow: 0px 10px 25px rgba(0,0,0, .1) ;
}
.image-container{
  height: 29.16vw;
  min-height: 260px;
}
.card-releases{
  background: linear-gradient(180deg, #f2f2f2, #e1e1e1);
}
.content-container{
  padding: 30px 80px 60px 80px;
  background-image: url("../../assets/images/releases-circles.png");
  background-position-y: center;
  background-position-x: -20%;
  font-size: 15px;
}
.circle-en{
  background-position-x: 120%;
}
.circle-ar{
  background-position-x: -20%;
}
.content-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: $--yellow;
  margin-bottom: 20px;
}
.card-title{
  font-size: 22px;
  width: 45%;
}
.share{
  cursor: pointer;
  width: 19px;
  img {
    width: 100%;
    height: 100%;
  }
}
.swipe{
  bottom: 15px !important;
}
.swipe div{
  color: #fff !important;
}
.description{
  line-height: 2;
  font-size: 14px;
}
.left-desc{
  padding-left: 45px;
}
.right-desc{
  padding-right: 45px;
}
@media (max-width: 1200px) {
  .release-header{
    padding: 0 40px;
  }
  .back-arrow-left{
    left: 40px;
  }
  .back-arrow-right{
    right: 40px;
  }
  .content-container {
    padding: 30px 40px 40px 40px;
  }
  .card-title{
    width: 60%;
  }
  .description{
    padding: 0 0 40px 0;
  }
}
@media (max-width: 700px) {
  .release-header{
    padding: 0 30px;
  }
  .back-arrow-left{
    left: 30px;
  }
  .back-arrow-right{
    right: 30px;
  }
  .content-container {
    padding: 30px 20px 40px 20px;
  }
  .card-title{
    width: 75%;
  }
  .description{
    padding: 0 0 40px 0;
  }
}
@media (max-width: 500px) {
  .release-header{
    padding: 0 25px;
  }
  .back-arrow-left{
    left: 25px;
  }
  .back-arrow-right{
    right: 25px;
  }
  .content-container {
    //padding: 30px 25px 40px 25px;
  }
  .card-title{
    width: 90%;
  }
  .description{
    padding: 0 0 40px 0;
  }
}
</style>
<style lang="scss">
@import "src/assets/sass/main";
ul.slick-dots{
  //transform: rotate(90deg);
  right: unset;
  left: unset;
  height: max-content;
  width: max-content;
  z-index: 201;
  padding: 0;
  //width: 150px;
  //top: calc(50% - 10px);
  //right: -30px;
  //width: 320px;
  //display: flex !important;
  //align-items: center !important;
  //justify-content: space-around !important;
  //height: 320px;
  //top: calc(50% - 160px);
  display: flex !important;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 80%;
  top: calc(50% - 40%);
}
.slick-dots li{
  margin: 10px 0px;
  padding: 0 5px;
  display: block;
}
.slick-dots li button:before{
  color: $--yellow;
  font-size: 8px;
  opacity:.4
}
.slick-dots li.slick-active button:before{
  color: $--yellow;
}
</style>
